import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center bg-white border-b border-gray-200 flex py-4 md:pl-4" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:mr-auto" }
const _hoisted_4 = { class: "py-6" }

import DataTable from "@/components/tools/DataTable.vue";
import TierDetailDialog from "@/components/dialogs/TierConfigDetailDialog.vue";
import TierCreateDialog from "@/components/dialogs/TierConfigDialog.vue";
import Navbar from "@/components/tools/Navbar.vue";
import { AxiosInstance } from "axios";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'TierConfig',
  setup(__props) {

const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const rowsData = ref([]);
const selectedRow = ref({
  id:'', paymentName: '', minAmount: '', maxAmount: ''
});

const showTierDetailDialog = ref(false);
const showCreateNewTierDialog = ref(false);
const isLoaded = ref(false);

const fetchTiers = async () => {
  isLoaded.value = false;

  const { data } = await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/tier-config/read`,
    {
      operator_id: store.state.selectedOperator.operatorId,
    }
  );
   rowsData.value =data.result.sort((a:any, b:any) => parseInt(a.minAmount) - parseInt(b.minAmount));
  isLoaded.value = true;
};

const columns = ref([
  {
    label: translate("messages.tierConfig.paymentName"),
    field: "Payment",
    format: (data: any) =>
      data.Payment.name,
  },
  {
    label: translate("messages.tierConfig.minAmount"),
    field: "minAmount",
    format: (data: any) =>
      !data.minAmount ? '' :
          (Number(data.minAmount)/100).toLocaleString("en", {
            useGrouping: true,
            minimumFractionDigits: 2,
          }),
  },
  {
    label: translate("messages.tierConfig.maxAmount"),
    field: "maxAmount",
    format: (data: any) =>
    !data.maxAmount ? '' :
          (Number(data.maxAmount)/100).toLocaleString("en", {
            useGrouping: true,
            minimumFractionDigits: 2,
          }),
  },
  {
    label: translate("messages.tierConfig.feeAmount"),
    field: "feeAmount",
    format: (data: any) =>
    !data.feeAmount ? '' :
          (Number(data.feeAmount)/100).toLocaleString("en", {
            useGrouping: true,
            minimumFractionDigits: 2,
          }),
  },
  {
    label: translate("messages.tierConfig.action"),
    field: "",
    isFunction: true,
    function: (data: any) => {
      selectedRow.value = { id:data.id, paymentName: data.Payment.name, minAmount: `${(Number(data.minAmount)/100).toFixed(2)}`, maxAmount: `${(Number(data.maxAmount)/100).toFixed(2)}`, payment: data.Payment, feeAmount:data.feeAmount / 100};
      showTierDetailDialog.value = true;
    },
    format: (data: any) => translate("messages.tierConfig.updateTierConfig"),
    class: () => "text-white bg-blue-400 cursor-pointer",
    permission: "TIER.MANAGE",
    styles: { td:{width:'120\px'} },
  },
  {
    label: '',
    field: "",
    isFunction: true,
    function:async (data: any) => {
      if (confirm(`Are you sure you want to delete this config? ( ${data.Payment.name} )`)) {
     await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/tier-config/delete`,
      {id:data.id}
    );
   fetchTiers();
  }
    },
    format: () => translate("messages.tierConfig.deleteTierConfig"),
    class: () => "text-white bg-red-400 cursor-pointer",
    permission: "TIER.MANAGE",
  },
]);

onMounted(async () => {
  await fetchTiers();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.tierConfig.tier')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(store).state.user.permissions.includes('TIER.MANAGE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateNewTierDialog.value = true)),
                class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-white mr-2",
                  icon: ['fas', 'plus'],
                  transform: ""
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.tierConfig.createNewTierConfig")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(DataTable, {
        data: rowsData.value,
        columns: columns.value,
        isLoaded: isLoaded.value
      }, null, 8, ["data", "columns", "isLoaded"])
    ]),
    _createVNode(TierDetailDialog, {
      show: showTierDetailDialog.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showTierDetailDialog).value = $event)),
      form: selectedRow.value,
      "onUpdate:form": _cache[2] || (_cache[2] = ($event: any) => ((selectedRow).value = $event)),
      onUpdate: _cache[3] || (_cache[3] = ($event: any) => (fetchTiers()))
    }, null, 8, ["show", "form"]),
    _createVNode(TierCreateDialog, {
      show: showCreateNewTierDialog.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showCreateNewTierDialog).value = $event)),
      onUpdate: _cache[5] || (_cache[5] = ($event: any) => (fetchTiers()))
    }, null, 8, ["show"])
  ], 64))
}
}

})